/* eslint-disable
    camelcase,
    consistent-return,
    no-return-assign,
    no-shadow
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';
import * as d3 from 'd3';
import $ from 'jquery';
import _ from 'underscore';
import {v4 as uuidv4} from 'uuid';

import * as benchlingUtil from 'BenchlingUtil';
import VirtualDigestTabTemplate from 'analyses/VirtualDigestTabTemplate';
import VirtualDigestMenuTemplate from 'analyses/VirtualDigestMenuTemplate';
import * as util from 'biojs/Util';
import * as selectioncontextmenu from 'components/SelectionContextMenu';
import FileStates from 'FileStates';
import * as ladders from 'molbio/virtual-digests/Ladders';
import {toFilename} from 'util/FileUtil';
import {appendSVGToSVG, getPNGFileForSVG} from 'util/SVGUtil';
import {pushToast} from 'nav/toasts/ToastActions';
import {ToastType} from 'nav/toasts/ToastConstants';
import notifications, {FOREVER_DURATION} from 'notifications';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import getTestProps from 'test/lib/cypress/getTestProps';

function getLegendInfo(model) {
  const lanes = [];
  const ladder = model.ladders().find((ladder) => ladder.id.toString() === model.get('ladderId'));
  lanes.push({index: 'Ladder', title: ladder.name});

  model.get('digests').each((digest, index) => {
    const sequence = digest.get('sequence');
    const names = digest
      .get('analysis')
      .get('enzymes')
      .map((id) => sequence.get('enzymes').get(id).get('name'));
    lanes.push({
      index: index + 1,
      title: `${sequence.get('_sequence').get('name')} - ${names.join(' ')}`,
    });
  });
  return lanes;
}

class OptionsView extends Backbone.View {
  static initClass() {
    this.prototype.className = 'navbar';
    this.prototype.template = VirtualDigestMenuTemplate;

    this.prototype.events = {
      'change select': 'changeLadder',
      'click .download-btn': 'downloadPNG',
    };
  }

  async copyPNG(imageURL) {
    const makeImagePromise = async () => {
      const response = await fetch(imageURL);
      const blob = await response.blob();
      return new Blob([blob], {type: 'image/png'});
    };

    // Firefox does not allow passing a Promise to ClipboardItem but Safari requires it
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=1619947
    if (benchlingUtil.firefox) {
      const response = await fetch(imageURL);
      const blob = await response.blob();
      await navigator.clipboard.write([
        new window.ClipboardItem({'image/png': new Blob([blob], {type: 'image/png'})}),
      ]);
    } else {
      await navigator.clipboard.write([new window.ClipboardItem({'image/png': makeImagePromise()})]);
    }

    pushToast({
      message: 'PNG copied',
      type: ToastType.SUCCESS,
    });
  }

  createSVG() {
    const legendRowHeight = 24;
    const legend = getLegendInfo(this.model);

    // Note this is definitely not great coupling, but the alternative is factoring out
    // all of the SVG rendering code from the view below.
    const digestSVGElement = this.model.get('bufferViewLayout').get('el').find('svg')[0].cloneNode(true);
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    // Split legend items into lines when the text is too long
    // Maximum length is 60 characters plus 10 characters for each digest column after the fourth
    const maxLegendChars = 60 + 10 * Math.max(legend.length - 4, 0);
    const legendRows = legend.flatMap(({index, title}) => {
      const rowSplitRegex = new RegExp(`(?:\\s|^)(\\S.{0,${maxLegendChars}}|\\S+)(?!\\S)`);
      return title
        .split(rowSplitRegex)
        .map((titlePart) => titlePart.trim())
        .filter((titlePart) => titlePart !== '')
        .map((titlePart, idx) => ({
          index: idx === 0 ? index : null,
          title: titlePart,
        }));
    });

    const pngHeight =
      parseInt(digestSVGElement.getAttribute('height'), 10) + (legendRows.length + 1) * legendRowHeight;
    const pngWidth = Math.max(parseInt(digestSVGElement.getAttribute('width'), 10), 500);

    renderToDOM(
      <g>
        <rect fill="white" width={pngWidth} height={pngHeight} />
        {legendRows.map(({index, title}, rowNumber) => (
          <g key={rowNumber} transform={`translate(10, ${legendRowHeight * (rowNumber + 1)})`}>
            {index && <text transform="translate(0, 0)">{index}</text>}
            <text transform={`translate(80, ${index ? 0 : -4})`}>{title}</text>
          </g>
        ))}
      </g>,
      svg
    );
    appendSVGToSVG({
      parentSVG: svg,
      childSVG: digestSVGElement,
      transform: `translate(0, ${(legendRows.length + 1) * legendRowHeight})`,
    });

    return svg;
  }

  async downloadPNG() {
    const toastId = uuidv4();
    pushToast({
      id: toastId,
      message: 'Creating PNG...',
      type: ToastType.INFO,
      duration: FOREVER_DURATION,
    });
    const digestSVG = this.createSVG();

    // Safari blocks calls to window.open during async calls, so we open the window here first
    // then set the location when the download url is ready.
    let windowReference;
    if (benchlingUtil.safari) {
      windowReference = window.open();
    }

    try {
      const pngURL = await getPNGFileForSVG(
        digestSVG,
        toFilename(`virtual_digest_sequence_${this.model.get('sequence').name()}`, 'png')
      );

      if (benchlingUtil.safari) {
        windowReference.location = pngURL;
      } else {
        window.open(pngURL);
      }
      pushToast({
        id: toastId,
        message: 'PNG downloaded',
        type: ToastType.SUCCESS,
        duration: FOREVER_DURATION,
        ...(window.ClipboardItem &&
          navigator.clipboard.write && {
            actionText: 'Copy to clipboard',
            onActionClick: () => {
              this.copyPNG(pngURL);
            },
          }),
      });
    } catch (error) {
      pushToast({
        id: toastId,
        message: notifications.getFriendlyError(error),
        type: ToastType.DANGER,
      });
      throw error;
    }
  }

  changeLadder() {
    return this.model.set({ladderId: this.$el.find('select option:selected').val()});
  }

  addLadderOption(ladder) {
    return this.$('select').append(new Option(ladder.name, ladder.id));
  }

  render() {
    this.$el.html(this.template());
    const allLadders = this.model.ladders();
    for (const ladder of Array.from(allLadders)) {
      this.addLadderOption(ladder);
    }
    const personalLadders = new ladders.Collection();
    personalLadders.fetch().done(() =>
      personalLadders.each((ladder) => {
        const ladder_dict = {
          id: ladder.id,
          name: ladder.get('name'),
          bands: ladder
            .bandSizes()
            .slice()
            .sort((a, b) => a - b),
        };
        // Have to do deep comparison of ladder_dict to membership in allLadders to determine if it should
        // be added to allLadders.
        const isNewCustomLadder = !allLadders.some(
          (item) =>
            item.id === ladder_dict.id &&
            item.name === ladder_dict.name &&
            item.bands.every((val, index) => val === ladder_dict.bands[index])
        );
        if (isNewCustomLadder) {
          allLadders.push(ladder_dict);
          this.addLadderOption(ladder_dict);
        }
      })
    );
    return this;
  }
}
OptionsView.initClass();

class TabView extends Backbone.View {
  static initClass() {
    this.prototype.id = 'virtual-gel';
    this.prototype.template = VirtualDigestTabTemplate;
    this.prototype.className = 'buffer-tab';

    this.prototype.attributes = {
      ...this.prototype.attributes,
      ...getTestProps({component: 'VirtualDigestView', element: 'root'}),
    };
  }

  initialize(options) {
    this.sequence = this.model.get('sequence');
    this.listenTo(this.model, 'change:ladderId', this.render);
    this.listenTo(this.model.get('digests'), 'add remove', this.render);
    this.listenTo(this.model.get('digests'), 'selectedFragmentChange', this.update);
    const listenToDigest = (digest) => this.listenTo(digest.get('analysis'), 'change:fragments', this.render);
    this.model.get('digests').each(listenToDigest);
    this.listenTo(this.model.get('digests'), 'add', listenToDigest);
    this.listenTo(
      this.model.get('digests'),
      'remove',
      // eslint-disable-next-line no-restricted-syntax
      _.bind(function (digest) {
        return this.stopListening(digest);
      }, this)
    );
    return (this.fileStates = FileStates.get());
  }

  update() {
    return (function (model, y, sequence, ref) {
      const layout = model.get('layout');
      // eslint-disable-next-line no-restricted-syntax
      let ladder = _.find(model.ladders(), (ladder) => ladder.id.toString() === model.get('ladderId'));

      y = d3
        .scaleLog()
        .domain([ladder.bands[0], ladder.bands[ladder.bands.length - 1]])
        .rangeRound([layout.gel.height - layout.gel.padding - layout.band.height, layout.gel.padding])
        .clamp(true);

      const data = [ladder].concat(model.get('digests').models);

      const header = d3.select(ref.el).select('g.header').selectAll('text').data(data);
      header
        .join('svg:text')
        .text((d, i) => {
          if (i === 0) {
            return 'Ladder';
          } else {
            return i;
          }
        })
        .attr('x', (d, i) => layout.lane.width * i + layout.lane.width / 2)
        .attr('y', layout.header.height / 2)
        .attr('text-anchor', 'middle');

      ladder = d3.select(ref.el).select('g.ladder-labels').selectAll('text').data(ladder.bands);
      ladder
        .join('svg:text')
        .text((d) => util.formatBaseCount(d))
        .attr('transform', (d) => `translate(0,${y(d) + Math.floor(layout.type.height / 3)})`);

      let lane = d3.select(ref.el).select('g.gel').selectAll('g.lane').data(data);

      const laneEnter = lane
        .enter()
        .append('svg:g')
        .attr('class', (d, i) => {
          if (i === 0) {
            return 'lane ladder';
          } else {
            return 'lane';
          }
        })
        .attr('transform', (d, i) => `translate(${layout.lane.width * i},0)`);

      laneEnter
        .append('svg:g')
        .attr('transform', `translate(${(layout.lane.width - layout.band.width) / 2},0)`)
        .attr('class', 'bands');

      lane = laneEnter.merge(lane);

      const bands = lane
        .select('g.bands')
        .selectAll('rect')
        .data((d, i) => d.bands || d.get('analysis').get('fragments').models);

      function handleClick(d, rightClick) {
        if (rightClick == null) {
          rightClick = false;
        }
        if (model.get('digests').at(0).get('sequence').fileState() == null) {
          return;
        }
        let selectedDigest = null;
        model.get('digests').each((digest, index) =>
          digest
            .get('analysis')
            .get('fragments')
            .each((fragment) => {
              if (fragment === d) {
                return (selectedDigest = digest);
              } else {
                return fragment.set({selected: false});
              }
            })
        );
        const target = selectedDigest.get('sequence');
        return ref.fileStates.selectFragment(target, d, rightClick);
      }

      bands
        .join('rect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', layout.band.width)
        .attr('height', layout.band.height)
        .attr('fill', (d) => {
          if (!_.isNumber(d)) {
            if (d.get('selected')) {
              return layout.band.active.fill;
            } else {
              return layout.band.fill;
            }
          } else {
            return layout.band.fill;
          }
        })
        .attr('transform', (d) => `translate(0,${_.isNumber(d) ? y(d) : y(d.get('length'))})`)
        .on('click', (e, d) => {
          if (!_.isNumber(d)) {
            return handleClick(d);
          }
        })
        .on('mouseover', function (e, d) {
          if (!_.isNumber(d)) {
            $(ref.el)
              .find('dl.highlighted dd')
              .text(util.formatBaseCount(d.get('length')));
            if (!d.get('selected')) {
              return d3.select(this).attr('fill', layout.band.active.fill);
            }
          }
        })
        .on('mouseleave', function (e, d) {
          if (!_.isNumber(d)) {
            let length = '--';
            const selected = d.collection.find((fragment) => fragment.get('selected'));
            if (selected != null) {
              length = util.formatBaseCount(selected.get('length'));
            }
            $(ref.el).find('dl.highlighted dd').text(length);
            if (!d.get('selected')) {
              return d3.select(this).attr('fill', layout.band.fill);
            }
          }
        })
        .on('contextmenu', (e, d) => {
          if (model.get('digests').at(0).get('sequence').fileState() == null) {
            return;
          }
          const digest = model.get('digests').find(
            (digest) =>
              digest
                .get('analysis')
                .get('fragments')
                .find((fragment) => fragment === d) != null
          );
          if (
            !_.isNumber(d) &&
            selectioncontextmenu.open(e, digest.get('sequence'), ['copy', 'copySpecial'])
          ) {
            return handleClick(d, true);
          }
        })
        .each((d) => {
          if (!_.isNumber(d) && d.get('selected') != null && d.get('selected')) {
            return $(ref.el)
              .find('dl.highlighted dd')
              .text(util.formatBaseCount(d.get('length')));
          }
        });

      return lane.exit().remove();
    })(this.model, this.y, this.sequence, this);
  }

  render() {
    this.$el.empty();

    const legend = getLegendInfo(this.model);
    this.$el.append(this.template({legend}));

    const layout = this.model.get('layout');

    d3.select(this.el)
      .append('svg')
      .attr('height', layout.padding + layout.gel.height + layout.header.height)
      .attr('width', layout.padding + layout.ladder.width + legend.length * layout.lane.width)
      .attr('data-test-component', 'VirtualDigestView')
      .attr('data-test-element', 'svgRoot')
      .append('g')
      .attr('transform', `translate(${layout.padding},${layout.padding})`);

    const container = d3.select(this.el).select('svg').select('g');
    container.append('g').attr('class', 'header').attr('transform', `translate(${layout.ladder.width},0)`);
    container
      .append('g')
      .attr('class', 'ladder-labels')
      .attr('transform', `translate(0,${layout.header.height})`);

    const gelContainer = container
      .append('g')
      .attr('class', 'gel-container')
      .attr('transform', `translate(${layout.ladder.width},${layout.header.height})`);

    gelContainer
      .append('svg:rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', legend.length * layout.lane.width)
      .attr('height', layout.gel.height)
      .attr('fill', layout.gel.fill);

    gelContainer.append('svg:g').attr('class', 'gel');

    this.update();
    return this;
  }
}
TabView.initClass();

export {OptionsView, TabView};
